// extracted by mini-css-extract-plugin
export default {"categoryDescription":"category-description_categoryDescription__1A5Fh","heading":"category-description_heading__RSe_p"};